import Link from "next/link";
import React, { useState } from "react";
import LockPasswordLineIcon from "remixicon-react/LockPasswordLineIcon";
import ArchiveFillIcon from "remixicon-react/ArchiveLineIcon";
import MapPinUserLineIcon from "remixicon-react/MapPinUserLineIcon";
import { SavedAddressesModal } from "./saved-addresses-modal";
import { ChangePasswordModal } from "./change-password-modal";

const AccountSettings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  return (
    <div className="bg-white rounded-3xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-bg2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-black">Account Settings</h2>
        <p className="text-gray-500 text-sm mt-1">
          Quick access to account features
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Change Password */}
        <div
          role="button"
          tabIndex={0}
          onClick={() => setIsChangePasswordOpen(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setIsChangePasswordOpen(true);
            }
          }}
          className="border-2 border-gray-200 rounded-2xl p-4 flex gap-6 hover:border-primary transition-colors cursor-pointer group"
        >
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-all duration-300 group-hover:bg-primary group-hover:text-white">
            <LockPasswordLineIcon size={26} />
          </div>
          <div>
            <h3 className="font-bold text-black text-base">Change Password</h3>
            <p className="text-gray-400 text-sm mt-1">Update your security</p>
          </div>
        </div>

        {/* Order History */}
        <Link
          href="/orders"
          className="border-2 border-gray-200 rounded-2xl p-4 flex gap-6 hover:border-primary transition-colors cursor-pointer group"
        >
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-all duration-300 group-hover:bg-primary group-hover:text-white">
            <ArchiveFillIcon size={26} />
          </div>
          <div>
            <h3 className="font-bold text-black text-base">Order History</h3>
            <p className="text-gray-400 text-sm mt-1">Track your orders</p>
          </div>
        </Link>

        {/* Saved Addresses */}
        <div
          role="button"
          tabIndex={0}
          onClick={() => setIsModalOpen(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setIsModalOpen(true);
            }
          }}
          className="border-2 border-gray-200 rounded-2xl p-4 flex gap-6 hover:border-primary transition-colors cursor-pointer group"
        >
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-all duration-300 group-hover:bg-primary group-hover:text-white">
            <MapPinUserLineIcon size={26} />
          </div>
          <div>
            <h3 className="font-bold text-black text-base">Saved Addresses</h3>
            <p className="text-gray-400 text-sm mt-1">Manage addresses</p>
          </div>
        </div>
      </div>
      <SavedAddressesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </div>
  );
};

export default AccountSettings;
